<template>
  <div>
    <ModalAlert 
      :id="'modal-app-patch-snapshot-error'"
      :show="show" 
      :variant="'danger'"
      :title="$t('engine.common.dialogSnapshotError.lblTitle', languageEngine)"
      :description_="$t('engine.common.dialogSnapshotError.lblDescription', languageEngine)"
      :confirm="$t('engine.common.dialogSnapshotError.btnReload', languageEngine)"
      :confirmVariant="'danger'"
      :showCancel="false"
      :showClose="false"
      :timer_="10"
      :noCloseOnEsc="true"
      :noCloseOnBackdrop="true"
      @onTimeout_="onConfirm"
      @onConfirm="onConfirm"
    >
      <template #description>
        <div class="fs-sa-16">{{ $t('engine.common.dialogSnapshotError.lblDescription', languageEngine) }}</div>
        <br/>
        <div class="fs-sa-12 text-danger"><b> Patch Error </b></div>
      </template>
    </ModalAlert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  components: {
    ModalAlert,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      patchError: "design/snapshot/patchError",
    }),
    show() {
      return this.patchError;
    },
  },
  methods: {
    onConfirm() {
      this.$store.dispatch("design/reload");
    },
  },
};
</script>